export const pinnedPost = {
  title: "SMASH THAT INTRO",
  date: "OCTOBER 31, 2023",
  excerpt:
    "Full-stack engineer from the Philippines, specializing in desktop customization, system optimization, and emerging web technologies. When the power goes out, I'm usually found riding my Moped.",
  path: "/about/",
  tags: [],
};

export const posts = [
  {
    title: "GEOFENCING WITHOUT POSTGIS: HOW 'GIG NEAR YOU' FINDS WORKERS IN TiiRADA",
    date: "JULY 30, 2026",
    readTime: "6 min read",
    excerpt:
      "The geo layer behind TiiRADA's best push — a hand-tuned bounding box for Davao del Norte, Ruby Haversine distance for the 15 km radius, and a town-string fallback that never drops a worker silently.",
    path: "/blog/geofencing-without-postgis-tiirada/",
    tags: ["Rails", "Geocoding", "Geofence", "TiiRADA"],
  },
  {
    title: "RAILS 8 + EXPO + REACT NATIVE PUSH NOTIFICATIONS: THE TiiRADA WAY",
    date: "JULY 30, 2026",
    readTime: "8 min read",
    excerpt:
      "Push notifications end to end — a Rails 8 backend speaking FCM HTTP v1 with a hand-rolled client, Solid Queue delivery, and a React Native client rendering it all through Notifee.",
    path: "/blog/rails-8-react-native-push-notifications/",
    tags: ["Rails", "Expo", "React Native", "FCM", "Push Notifications"],
  },
  {
    title: "THE TERMINAL-FIRST DEV WORKFLOW: CLI TOOLS, AI AGENTS & MCP",
    date: "JULY 23, 2026",
    readTime: "5 min read",
    excerpt:
      "The actual toolchain behind the build — mise and fnm for runtimes, git/gh/vercel for plumbing, opencode + Codex + Ollama for AI, MCP servers for live data, and agent workflows for rituals.",
    path: "/blog/terminal-first-dev-workflow/",
    tags: ["CLI", "MCP", "AI Agents", "Workflow"],
  },
  {
    title: "SETTING UP PRODUCTION-LIKE LOCAL INFRA ON UBUNTU 26.04",
    date: "JULY 16, 2026",
    readTime: "6 min read",
    excerpt:
      "How the TiiRADA workspace mirrors production on a single machine — native PostgreSQL 18, MinIO object storage via Docker Compose, and a Solid Queue worker, all booted by one command.",
    path: "/blog/local-infra-ubuntu-26-04/",
    tags: ["Ubuntu", "PostgreSQL", "MinIO", "Docker"],
  },
  {
    title: "VOICE-TO-TEXT ON GNOME: OPENAI WHISPER + SPEECH2TEXT EXTENSION",
    date: "JULY 9, 2026",
    readTime: "4 min read",
    excerpt:
      "Local, offline dictation on the GNOME desktop — a Speech2Text Shell extension driving an OpenAI Whisper service over D-Bus, running the small.en model on CPU.",
    path: "/blog/gnome-voice-to-text-whisper/",
    tags: ["GNOME", "Whisper", "Linux"],
  },
  {
    title: "BUILDING TiiRADA: A COMMUNITY-FIRST MARKETPLACE",
    date: "JUNE 9, 2026",
    readTime: "8 min read",
    excerpt:
      "TiiRADA is a non-custodial, reputation-based marketplace built for the Davao Region — connecting skilled Tiradors (plumbers, carpenters, lechoneros, welders, and more) directly with clients, without platform cuts or banking hurdles. Built with Rails, React Native, Expo, Fly.io Postgres, and more.",
    path: "/blog/tiirada-mobile/",
    tags: ["Rails", "React Native", "Expo"],
    pinned: true,
  },
  {
    title: "MY ULTIMATE CINEMATIC VAULT",
    date: "FEBRUARY 5, 2026",
    readTime: "3 min read",
    excerpt:
      "A curated archive of Charlie's favorite TV series, movies, and directors. From time-travel paradoxes to historical war dramas — a journey through essential frequencies.",
    path: "/favorites/",
    tags: ["Favorites"],
  },
  {
    title: "UBUNTU POWER-USER WIKI",
    date: "FEBRUARY 2, 2026",
    readTime: "5 min read",
    excerpt:
      "From Terminal tab renaming scripts to GNOME developer optimizations — a curated collection of essential tweaks for the modern Linux workstation.",
    path: "/blog/ubuntu-linux-tweaks-wiki/",
    tags: ["Linux", "GNOME", "Terminal"],
  },
  {
    title: "THE TOKEN AND THE RAILS: A TALE OF AUTHENTICATION",
    date: "FEBRUARY 1, 2026",
    readTime: "3 min read",
    excerpt:
      "A narrative journey through the secure handshake of modern authentication — where the stateless Token meets the robust Rails guard, ensuring every request finds its true home without speaking a name.",
    path: "/blog/the-token-and-the-rails/",
    tags: ["Auth", "Rails"],
  },
  {
    title: "FCM PUSH NOTIFICATIONS: ANDROID, REACT NATIVE & RAILS",
    date: "JANUARY 30, 2026",
    readTime: "5 min read",
    excerpt:
      "A technical breakdown of implementing cross-platform push notifications using Firebase Cloud Messaging and Sidekiq background workers.",
    path: "/blog/fcm-push-notifications-rails-react-native/",
    tags: ["FCM", "React Native", "Android", "Rails", "Sidekiq"],
  },
  {
    title: "RESEND + RAILS: MODERN EMAIL INFRASTRUCTURE",
    date: "JANUARY 30, 2026",
    readTime: "4 min read",
    excerpt:
      "Seamless email delivery for mobile apps — integrating Resend with Rails and Sidekiq for a non-blocking user experience.",
    path: "/blog/resend-rails-sidekiq-emails/",
    tags: ["Resend", "Rails", "Sidekiq", "Email"],
  },
  {
    title: "RAILS, REDIS & SIDEKIQ: SCALING NOTIFICATIONS",
    date: "JANUARY 30, 2026",
    readTime: "4 min read",
    excerpt:
      "Architecting high-performance notification systems by offloading heavy synchronous tasks to Redis-backed Sidekiq workers.",
    path: "/blog/rails-redis-sidekiq-notifications/",
    tags: ["Rails", "Redis", "Sidekiq"],
  },
  {
    title: "REACT NATIVE & EXPO: THE ESSENTIALS",
    date: "JANUARY 30, 2026",
    readTime: "5 min read",
    excerpt:
      "Mastering essential Expo commands, configuring local EAS builds, and setting up Android emulators and real devices for professional mobile engineering.",
    path: "/blog/react-native-expo-essentials/",
    tags: ["React Native", "Expo", "EAS"],
  },
];